import { render, staticRenderFns } from "./LoaderScaleUp.vue?vue&type=template&id=06f5df43&scoped=true&"
import script from "./LoaderScaleUp.vue?vue&type=script&lang=js&"
export * from "./LoaderScaleUp.vue?vue&type=script&lang=js&"
import style0 from "./LoaderScaleUp.vue?vue&type=style&index=0&id=06f5df43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5df43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f5df43')) {
      api.createRecord('06f5df43', component.options)
    } else {
      api.reload('06f5df43', component.options)
    }
    module.hot.accept("./LoaderScaleUp.vue?vue&type=template&id=06f5df43&scoped=true&", function () {
      api.rerender('06f5df43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loaders/LoaderScaleUp.vue"
export default component.exports